import styled from '@emotion/styled';
import { Link } from 'gatsby';
import React from 'react';

import bloombergRadioLogo from '../../icons/smartdraw/logo-bloomberg_radio.svg';
import businessInsiderLogo from '../../icons/smartdraw/logo-business_insider.svg';
import cnbcLogo from '../../icons/smartdraw/logo-cnbc.svg';
import forbesLogo from '../../icons/smartdraw/logo-forbes.svg';
import nytLogo from '../../icons/smartdraw/logo-nyt.svg';
import { theme } from '@kindur/components';

const Container = styled('div')`
  margin: 0 auto;
  max-width: 800px;

  ${theme.breakpoints.tabletDown} {
    padding: 0 2rem;
  }
`;
const Inner = styled('div')``;
const Title = styled('h2')`
  font-family: 'DM Sans', sans-serif;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.21px;
  line-height: 32px;
  margin-top: 48px;

  ${theme.breakpoints.tabletDown} {
    margin-top: 1rem;
  }
`;
const Copy = styled('div')`
  font-family: 'DM Sans', sans-serif;
  font-size: 18px;
  letter-spacing: 0.23px;
  line-height: 32px;
  a {
    color: #fff;
  }

  ${theme.breakpoints.tabletDown} {
    margin-bottom: 2rem;
  }
`;
const Logos = styled('div')`
  margin: 0;
  padding: 32px 0;
`;
const Logo = styled('img')`
  margin: 0 32px 32px 0;
  max-height: 2rem;
`;

export default ({ content }) => (
  <Container>
    <Inner className={`border-top`}>
      <Title>About Kindur</Title>
      <Copy>
        {content.copy} <Link to={`/about`}>More about us.</Link>
      </Copy>
      <Logos>
        {[
          [cnbcLogo, 'CNBC'],
          [nytLogo, 'The New York Times'],
          [forbesLogo, 'Forbes'],
          [businessInsiderLogo, 'Business Insider'],
          [bloombergRadioLogo, 'Bloomberg Radio']
        ].map(([src, alt], i) => (
          <Logo key={`logo-${i}`} {...{ src, alt }} />
        ))}
      </Logos>
    </Inner>
  </Container>
);
